import { render, staticRenderFns } from "./StepSix.vue?vue&type=template&id=74bcead3&"
import script from "./StepSix.vue?vue&type=script&lang=js&"
export * from "./StepSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports